import React, {useEffect, useRef, useState} from 'react';
import './CaseStudySlider.css';
import {useTranslation} from "react-i18next";

const CaseStudySlider = () => {
    const {t} = useTranslation();

    const slides = [
        {
            title: t("case-study-slider_badee_title"),
            text: t("case-study-slider_badee_text"),
            image: 'software_developer.webp',
            link: '/case-studies/mobile-application'
        },
        {
            title: t("case-study-slider_automotive_title"),
            text: t("case-study-slider_automotive_text"),
            image: 'automotive.webp',
            link: '/case-studies/micro-service-architecture'
        },
        {
            title: t("case-study-slider_ci-cd_title"),
            text: t("case-study-slider_ci-cd_text"),
            image: 'devops.webp',
            link: '/case-studies/ci-cd'
        }
    ];

    const [activeIndex, setActiveIndex] = useState(2);
    const sliderRef = useRef(null);
    const intervalRef = useRef(null);

    const startAutoSlide = () => {
        intervalRef.current = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
        }, 4500);
    };

    useEffect(() => {
        const slider = sliderRef.current;
        if (!slider) return;

        let isDown = false;
        let startX;
        let scrollLeft;

        const mouseDownHandler = (e) => {
            e.preventDefault();
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
            clearInterval(intervalRef.current); // Clear interval on user interaction
        };

        const mouseLeaveHandler = () => {
            isDown = false;
            slider.classList.remove('active');
        };

        const mouseUpHandler = () => {
            isDown = false;
            slider.classList.remove('active');
            startAutoSlide(); // Restart interval after user interaction
        };

        const mouseMoveHandler = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2;
            slider.scrollLeft = scrollLeft - walk;
        };

        slider.addEventListener('mousedown', mouseDownHandler);
        slider.addEventListener('mouseleave', mouseLeaveHandler);
        slider.addEventListener('mouseup', mouseUpHandler);
        slider.addEventListener('mousemove', mouseMoveHandler);

        return () => {
            slider.removeEventListener('mousedown', mouseDownHandler);
            slider.removeEventListener('mouseleave', mouseLeaveHandler);
            slider.removeEventListener('mouseup', mouseUpHandler);
            slider.removeEventListener('mousemove', mouseMoveHandler);
        };
    }, []);

    useEffect(() => {


        startAutoSlide();

        return () => clearInterval(intervalRef.current);
    }, [slides.length]);

    return (
        <div className="case-study-slider">
            <div className="slider-container" ref={sliderRef}>
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`slide ${activeIndex === index ? 'is-active' : ''}`}
                        onClick={() => setActiveIndex(index)}
                    >
                        <div className="slide-backdrop">
                            <img src={slide.image} alt={slide.title} className="slide-image"/>
                            <div className="slide-overlay"/>
                        </div>
                        <div className="slide-content">
                            <h3 className={activeIndex === index ? "slide-title HeadingThree" : "slide-title Body"}>{slide.title}</h3>
                            <div>
                                <p className="slide-text">{slide.text}</p>
                                <a href={slide.link} className="slide-link">
                                    {t("case-study-slider_read-more")} <div className={"arrow-right"}><img src={"/link_arrow.svg"} alt=""/></div>
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CaseStudySlider;